import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AssetDto, Tag } from '@nusign/picflow-backend-types';
import { tap } from 'rxjs';
import { AppConfigService } from '../providers/config.service';
import { ObservableDataLoaderService } from './observable-data-loader.service';

@Injectable({
  providedIn: 'root',
})
export class AssetTagService {
  private http = inject(HttpClient);
  private config = inject(AppConfigService);
  private loader = inject(ObservableDataLoaderService);

  public add(asset: AssetDto, tag: Tag) {
    return this.http.put<void>(`${this.config.apiEndpoint}/assets/${asset.id}/tags/${tag.id}`, {}).pipe(
      tap(() => {
        this.loader.update(`assets_${asset.gallery}_${asset.section}`, (assets: AssetDto[]) => {
          if (!assets) return assets;
          if (!Array.isArray(assets)) return assets;
          assets.forEach(_asset => {
            if (_asset.id === asset.id && !_asset.tags.some(t => t.id === tag.id)) {
              _asset.tags.push(tag);
            }
          });
          return assets;
        });
        this.loader.update(`assets_${asset.id}`, (_asset: AssetDto) => {
          if (!_asset) return _asset;
          if (_asset.id === asset.id && !_asset.tags.some(t => t.id === tag.id)) {
            _asset.tags.push(tag);
          }
          return _asset;
        });
      })
    );
  }

  public remove(asset: AssetDto, tag: Tag) {
    return this.http.delete(`${this.config.apiEndpoint}/assets/${asset.id}/tags/${tag.id}`).pipe(
      tap(() => {
        this.loader.update(`assets_${asset.gallery}_${asset.section}`, (assets: AssetDto[]) => {
          if (!assets) return assets;
          if (!Array.isArray(assets)) return assets;
          assets.forEach(_asset => {
            if (_asset.id === asset.id) {
              _asset.tags = _asset.tags.filter(t => t.id !== tag.id);
            }
          });
          return assets;
        });
        this.loader.update(`assets_${asset.id}`, (_asset: AssetDto) => {
          if (!asset) return asset;
          if (_asset.id === asset.id) {
            _asset.tags = _asset.tags.filter(t => t.id !== tag.id);
          }
          return _asset;
        });
      })
    );
  }
}
